import React, { useEffect } from 'react';
import logo from './logo.svg';
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDispatch } from 'react-redux';

import { fetchIssueTypesData } from './store/Actions/IssueTypes/IssueTypes';
import { fetchSettingsData } from './store/Actions/Settings/Settings';

import routes from './routes';


const App = (props) => {

  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(fetchIssueTypesData());
    dispatch(fetchSettingsData());
  }, []);

  return (
    <React.Fragment>
      <Router>
        {
          routes.map((route, index) => (
              <Route path={route.path} exact={route.exact} component={route.component} key={index} />
          ))
        }
      </Router>
    </React.Fragment>

  );
}

export default App;
